import api from '../..'

type Id = string | number

export type RestartEvaluationResultsOptions = {
  sendReport?: boolean
  keepAdvance?: boolean
}

const restartEvaluationResults = (
  course: Id,
  evaluation: Id,
  options?: RestartEvaluationResultsOptions
) => {
  return api.delete(
    `administration/courses/${course}/evaluations/${evaluation}/results`,
    {
      data: { options },
    }
  )
}
export default restartEvaluationResults
